// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class RestoreLobbyAction implements flatbuffers.IUnpackableObject<RestoreLobbyActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RestoreLobbyAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRestoreLobbyAction(bb:flatbuffers.ByteBuffer, obj?:RestoreLobbyAction):RestoreLobbyAction {
  return (obj || new RestoreLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRestoreLobbyAction(bb:flatbuffers.ByteBuffer, obj?:RestoreLobbyAction):RestoreLobbyAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RestoreLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyRestoreLobby;
}

static startRestoreLobbyAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyRestoreLobby);
}

static endRestoreLobbyAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRestoreLobbyAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  RestoreLobbyAction.startRestoreLobbyAction(builder);
  RestoreLobbyAction.addType(builder, type);
  return RestoreLobbyAction.endRestoreLobbyAction(builder);
}

unpack(): RestoreLobbyActionT {
  return new RestoreLobbyActionT(
    this.type()
  );
}


unpackTo(_o: RestoreLobbyActionT): void {
  _o.type = this.type();
}
}

export class RestoreLobbyActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyRestoreLobby
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return RestoreLobbyAction.createRestoreLobbyAction(builder,
    this.type
  );
}
}
